import '../../util/string';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { Grid, IconButton } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import ImageIcon from '@material-ui/icons/Image';
import FlareIcon from '@material-ui/icons/Flare';
import { makeStyles } from '@material-ui/core/styles';
import Brightness5Icon from '@material-ui/icons/Brightness5';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import style from './FinishingRetainerTabs.modual.css';
import AlertDialog from '../Dialog/Dialog';
import { withLang } from '../../util/lang';

const styles = (theme) => ({
    root: {
        margin: '48px auto',
        [theme.breakpoints.down('sm')]: {
            margin: '0 auto',
        },
        [theme.breakpoints.up('lg')]: {
            width: '70%',
            minHeight: '400px',
        },
    },
    tabText: {
        marginBlockStart: '8px',
        marginBlockEnd: '8px',
        fontSize: '14px',
        color: '#797979',
        cursor: 'pointer',
    },
    tabTextActive: {
        marginBlockStart: '8px',
        marginBlockEnd: '8px',
        fontSize: '14px',
        color: '#2eafb6',
        cursor: 'pointer',
    },
});

class FinishingRetainerTabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstNameDialogOpen: false,
            lastNameDialogOpen: false,
            cityDialogOpen: false,
            zipCodeDialogOpen: false,
            phoneDialogOpen: false,
        };
        //this.handleChangeTabLocal = this.handleChangeTabLocal.bind(this)
        //  this.handleDialogClose = this.handleDialogClose.bind(this)
    }

    componentDidMount() {}
    render() {
        const { classes } = this.props;

        let errors = this.props.NewPaitientData.errors;

        let photos_errors = errors.filter((v) => {
            return v.id === 'photo';
        });
        let impression_errors = errors.filter((v) => {
            return v.id === 'impression';
        });

        return (
            <Grid
                container
                style={{
                    padding: 1,
                }}
                className={style.customScrollBar}
            >
                <div style={{ display: 'flex', margin: 'auto' }}>
                    <Grid item style={{ textAlign: 'center', display: 'flex' }}>
                        <div className={style.iconButtonContainer} onClick={() => this.props.handleChangeTabLocal(0)}>
                            <div className={style.CustomBadgeContainer}>
                                {photos_errors[0] && !photos_errors[0].valid ? (
                                    <span className={style.CustomBadge}>*</span>
                                ) : (
                                    <span className={style.CustomBadge} style={{ display: 'none' }}>
                                        *
                                    </span>
                                )}
                                <IconButton
                                    aria-label="delete"
                                    style={{
                                        background: this.props.selectedTab === '0' ? '#2eafb6' : '#bababa',
                                    }}
                                    className={style.iconButton}
                                >
                                    <ImageIcon />
                                </IconButton>
                            </div>
                            <p className={this.props.selectedTab === '0' ? classes.tabTextActive : classes.tabText}>
                                {this.get('@global.fields.photos')}
                            </p>
                        </div>
                        {this.props.tabMode.includes('impression') ? (
                            <div className={style.iconButtonArrowContainer}>
                                <IconButton aria-label="delete" disabled className="iconButtonArrow">
                                    <KeyboardArrowRightIcon />
                                </IconButton>
                            </div>
                        ) : (
                            <></>
                        )}
                        {this.props.tabMode.includes('impression') ? (
                            <div
                                className={style.iconButtonContainer}
                                onClick={() => this.props.handleChangeTabLocal(1)}
                            >
                                <div className={style.CustomBadgeContainer}>
                                    {impression_errors[0] && !impression_errors[0].valid ? (
                                        <span className={style.CustomBadge}>*</span>
                                    ) : (
                                        <span className={style.CustomBadge} style={{ display: 'none' }}>
                                            *
                                        </span>
                                    )}
                                    <IconButton
                                        aria-label="delete"
                                        style={{
                                            background: this.props.selectedTab === '1' ? '#2eafb6' : '#bababa',
                                        }}
                                        className={style.iconButton}
                                    >
                                        <InfoIcon />
                                    </IconButton>
                                </div>
                                <p className={this.props.selectedTab === '1' ? classes.tabTextActive : classes.tabText}>
                                    {this.get('@NewPatient.tabs.impression')}
                                </p>
                            </div>
                        ) : (
                            <></>
                        )}

                        <div className={style.iconButtonArrowContainer}>
                            <IconButton aria-label="delete" disabled className="iconButtonArrow">
                                <KeyboardArrowRightIcon />
                            </IconButton>
                        </div>

                        <div className={style.iconButtonContainer} onClick={() => this.props.handleChangeTabLocal(2)}>
                            <IconButton
                                aria-label="delete"
                                style={{
                                    background: this.props.selectedTab === '2' ? '#2eafb6' : '#bababa',
                                }}
                                className={style.iconButton}
                            >
                                <InsertDriveFileIcon />
                            </IconButton>
                            <p className={this.props.selectedTab === '2' ? classes.tabTextActive : classes.tabText}>
                                {this.get('@NewPatient.tabs.summary')}
                            </p>
                        </div>
                    </Grid>
                </div>
            </Grid>
        );
    }
}
const mapStateToProps = (store) => {
    return {
        NewPaitientData: store.newPatientReducer,
        lang: store.lang,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        ErrorData: (errorMsg) => dispatch({ type: 'NEW_PATIENT_DATA_ERROR', errorMsg: errorMsg }),
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(withRouter(withLang(FinishingRetainerTabs, 'FinishingRetainerTabs'))));
